import Vue from 'vue'
import moment from 'moment'

Vue.filter('timeFilter', function (value, formatString) {
  formatString = formatString || 'YYYY-MM-DD'
  if (value) {
    return moment(value).format(formatString) // .add(8, 'hour')
  } else {
    return '无'
  }
})
